export function MenuIcon({ size = 24 }: { size?: number }) {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={size}
            height={size}
            viewBox='0 0 24 24'
            style={{ fill: 'currentcolor' }}
        >
            <path d='M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z'></path>
        </svg>
    );
}
